
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Profile() {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-16">
        {/* Hero Section */}
        <section 
          className="relative py-32 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20singer-songwriter%20with%20acoustic%20guitar%2C%20artistic%20lighting%2C%20intimate%20studio%20setting%2C%20warm%20and%20emotional%20atmosphere%2C%20simple%20clean%20background%2C%20professional%20music%20photography&width=1920&height=800&seq=profile-hero&orientation=landscape')`
          }}
        >
          <div className="container mx-auto px-6 text-center text-white">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">Profile</h1>
            <p className="text-xl md:text-2xl text-gray-200 max-w-2xl mx-auto">
              音楽への想いと歩んできた道のり
            </p>
          </div>
        </section>

        {/* Profile Content */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center max-w-6xl mx-auto">
              {/* Profile Image */}
              <div className="order-2 lg:order-1">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20singer-songwriter%20holding%20acoustic%20guitar%2C%20warm%20natural%20lighting%2C%20artistic%20composition%2C%20emotional%20expression%2C%20simple%20clean%20background%2C%20professional%20music%20photography%20style&width=600&height=800&seq=profile-main&orientation=portrait"
                  alt="Artist Profile"
                  className="w-full max-w-md mx-auto rounded-2xl shadow-2xl object-cover object-top"
                />
              </div>

              {/* Profile Info */}
              <div className="order-1 lg:order-2">
                <h2 className="text-4xl font-bold mb-6">久下 暁雅</h2>
                <h3 className="text-xl text-gray-600 mb-8">Singer-Songwriter</h3>
                
                <div className="space-y-6 text-gray-700 leading-relaxed">
                  <p>
                    1995年東京生まれ。幼少期からピアノを始め、中学時代にギターと出会う。
                    高校時代から作詞作曲を始め、大学在学中にストリートライブを開始。
                  </p>
                  
                  <p>
                    2018年にメジャーデビュー。心に響くメロディーと等身大の歌詞で多くの人々に愛され続けている。
                    これまでに5枚のアルバムと15枚のシングルをリリース。
                  </p>
                  
                  <p>
                    「音楽を通じて人々の心に寄り添いたい」という想いを胸に、
                    全国各地でライブ活動を精力的に行っている。
                  </p>
                </div>

                <div className="mt-8 grid grid-cols-2 gap-6">
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">出身地</h4>
                    <p className="text-gray-600">東京都</p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">デビュー</h4>
                    <p className="text-gray-600">2018年</p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">楽器</h4>
                    <p className="text-gray-600">ギター、ピアノ</p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">ジャンル</h4>
                    <p className="text-gray-600">アコースティック</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Career Timeline */}
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold mb-4">Career Timeline</h2>
              <p className="text-xl text-gray-600">これまでの歩み</p>
            </div>

            <div className="max-w-4xl mx-auto">
              <div className="space-y-8">
                {[
                  { year: '2024', event: '春のアコースティックツアー開催', description: '全国5都市を巡るツアーを開催' },
                  { year: '2023', event: '5thアルバム「心の旋律」リリース', description: 'オリコン週間チャート3位を記録' },
                  { year: '2022', event: '初の武道館公演開催', description: '念願の武道館でのワンマンライブを成功' },
                  { year: '2020', event: '4thアルバム「静寂の中で」リリース', description: 'コロナ禍での想いを込めた作品' },
                  { year: '2018', event: 'メジャーデビュー', description: '1stシングル「始まりの歌」でデビュー' },
                  { year: '2015', event: 'ストリートライブ開始', description: '渋谷や新宿でのストリートライブを開始' }
                ].map((item, index) => (
                  <div key={index} className="flex items-start space-x-6">
                    <div className="flex-shrink-0 w-20 text-right">
                      <span className="text-2xl font-bold text-black">{item.year}</span>
                    </div>
                    <div className="flex-shrink-0 w-4 h-4 bg-black rounded-full mt-2"></div>
                    <div className="flex-1">
                      <h3 className="text-xl font-semibold mb-2">{item.event}</h3>
                      <p className="text-gray-600">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}